import { render, staticRenderFns } from "./researchReport.vue?vue&type=template&id=ab53228a&scoped=true&"
import script from "./researchReport.vue?vue&type=script&lang=js&"
export * from "./researchReport.vue?vue&type=script&lang=js&"
import style0 from "./researchReport.vue?vue&type=style&index=0&id=ab53228a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab53228a",
  null
  
)

export default component.exports